import React from 'react'
import { Pill } from '@myxplor/ui'

const isWarning = (status = '') =>
  ['no ccms', 'warning', 'accs ended'].includes(status.toLowerCase())

export const isError = (status = '', other_statuses = []) =>
  status.toLowerCase() === 'missing approval'

const shouldDisplay = (status = '') =>
  !['', 'matched', 'inactive'].includes(status.toLowerCase())

const MatchPill = ({ status }) =>
  Array.isArray(status)
    ? status.map((s, i) => showStatus(s, i, status))
    : showStatus(status)

const showStatus = (status, key = 0, other_statuses) =>
  shouldDisplay(status) ? (
    <Pill
      warning={isWarning(status)}
      error={isError(status, other_statuses)}
      key={`Pill_${key}`}
    >
      {status}
    </Pill>
  ) : null

export default MatchPill



// WEBPACK FOOTER //
// ./src/care-enrolments/list-item/match-pill.jsx